import React from "react";
import { EliminatedIcon, PassIcon } from "./PassFailCriteria.js";
import { criteriaColors as colors } from "../../reducer/response.js";


const avatarStyle = {
  width: 16,
  height: 16,
  float: "left",
  margin: "0 2px",
  padding: 2,
  textAlign: "center",
  position: 'relative',
  top: -1,
  opacity: 0.9,
  borderRadius: 3,
  fontSize: 14
};

const containerStyle = {
  width: ((avatarStyle.width + avatarStyle.padding + 4) * 5) + 36 + 10,
  paddingLeft: 10,
  flex: 1,
  maxWidth: ((avatarStyle.width + avatarStyle.padding + 4) * 5) + 36 + 10,
};

const ColorCodedCriteriaAvatar = ({ color, count }) => {
  let fontColor = (color === "rgb(0,0,0)" || color === "rgb(250,20,27)") ? "white" : "black"

  return (
    <div style={{ ...avatarStyle, color: fontColor,  backgroundColor: color, fontWeight:"bold" }}>{count}</div>
  );
}

const ColorCodedCriteriaAvatars = ({ eliminated, eliminatedBy, metCriteria, onClick, style, innerStyle, hideColorCoding }) => {
  const criteria = [...eliminatedBy, ...metCriteria].sort(
    (a, b) => colors.indexOf(a.color) - colors.indexOf(b.color)
  );
  const counts = criteria.filter((c) => !c.or).reduce((counts, criteria) => {
    if (!counts[criteria.color]) {
      counts[criteria.color] = 1;
    } else {
      counts[criteria.color]++;
    }
    return counts;
  }, {});

  const topOrScores = {};
  criteria.filter((c) => !!c.or).forEach((c) => {
    if (!topOrScores[c.or]) {
      topOrScores[c.or] = c.color;
    } else {
      if (colors.indexOf(c.color) > colors.indexOf(topOrScores[c.or])) {
        topOrScores[c.or] = c.color;
      }
    }
  });
  for (var key in topOrScores) {
    if (!counts[topOrScores[key]]) {
      counts[topOrScores[key]] = 1;
    } else {
      counts[topOrScores[key]]++;
    }
  }

  if (hideColorCoding) {
    let total = 0;
    for (var key in counts) {
      if (key !== 'rgb(0,0,0)') {
        total = total + counts[key];
        delete counts[key];
      }
    }
    if (total > 0) {
      counts[colors[colors.length - 1]] = total;
    }
  }

  return (
    <div style={{ textAlign: "center", paddingTop: 3, paddingLeft: 10, cursor: "pointer", ...(style || {}) }} onClick={onClick}>
      {eliminated ? <EliminatedIcon /> : <PassIcon />}
      <div style={{
        width: containerStyle.width - 36,
        textAlign: 'left',
        display: 'inline-block',
        marginLeft: 10,
        ...(innerStyle || {})
      }}>
        {Object.keys(counts).sort((a, b) => colors.indexOf(a) - colors.indexOf(b)).map(color => {
          return (
            <ColorCodedCriteriaAvatar
              key={color}
              color={color}
              count={counts[color]}
            />
          );
        })}
      </div>
    </div>
  );
};

ColorCodedCriteriaAvatars.style = containerStyle;

export default ColorCodedCriteriaAvatars;
